<template>
  <transition name="fade-in-up">
    <div class="crm-module">
      <router-view></router-view>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
};
</script>
